module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANZJREFUeNpiYEAHUZ+uSoFoJiDjP0wQIIAwlcClAQIIK2CEKgOpkAaxl/FpPwMIIAaiAFBXGgsyB8ZmQjITDrA6AyCAiLaHCY+kFLLdyA5ygDJvAbEPEG9B1siCxT3SDJQAgAAiGjAS42N4QBIDWAiZhFMhVMEWnCZCw/ECLhuQ3bgfiA1wKiQ2ATBRPcABAoz+MUhsuiYYgfjSPTRZM0Cz7SyiUgSSAWxASgTKfUN2EkMCIkgu2kKygWjpwxGac4kGoBy9Hyk8HCmNIJALHaiZbAZ/ygYA33tM0UpkWVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarmList/list_icon_signal_2.png
// module id = VU2i
// module chunks = 1